/** Human (nb-NO) rendering of the stylist's brief and the owner's three framing facts. */

export const FURNISHING_NB = { unfurnished: "Umøblert", partly_furnished: "Delvis møblert", furnished: "Møblert", unknown: "Møblering ikke oppgitt" };
export const STYLING_NB = { digihome: "La DigiHome style", off: "Ingen styling" };
export const STYLING_LEVEL_NB = { none: "Ingen styling", recommended: "Anbefalt styling", inviting: "Mer innbydende", furniture_only: "Løse møbler", furniture_and_textiles: "Møbler + tekstiler" };
export const CURTAINS_NB = { keep_existing: "gardiner beholdes som i bildet", allowed: "gardiner kan legges til", forbidden: "ingen gardiner lagt til" };
export const ART_DIRECTION_NB = { nordic_plain: "Nordisk, nøkternt", nordic_hospitality: "Nordisk, gjesteklart" };

const ITEM_NB = {
  bed: "seng", nightstand: "ett nattbord", nightstands: "to nattbord", "table lamp": "én bordlampe", rug: "teppe", art: "ett bilde",
  desk: "skrivebord", "dresser or desk": "kommode eller skrivebord", dresser: "kommode", armchair: "lenestol", sofa: "sofa",
  "coffee table": "sofabord", "side table": "sidebord", "floor lamp": "gulvlampe", lamps: "lamper", plant: "plante", "dining set": "spisegruppe",
  "dining table": "spisebord", sideboard: "skjenk", shelf: "hylle", "desk lamp": "skrivebordslampe", textile: "tekstil", towels: "håndklær",
  "luggage rack or bench": "benk",
};

/** Detect the owner's furnishing fact from the listing text (mirrors backend pipeline/stylist.derive_furnishing). */
export function deriveFurnishing(...texts) {
  const blob = texts.filter(Boolean).join(" ").toLowerCase();
  if (!blob) return null;
  if (/\b(umøblert|umoblert|unfurnished|ikke møblert)\b/.test(blob)) return "unfurnished";
  if (/\b(delvis møblert|delvis moblert|partly furnished|semi[- ]furnished)\b/.test(blob)) return "partly_furnished";
  if (/\b(fullt møblert|møblert|moblert|furnished)\b/.test(blob)) return "furnished";
  return null;
}

/** "seng 140 cm · ett nattbord · én bordlampe · teppe · ett bilde · skrivebord (hvis plass)" */
export function briefChips(brief, { includeOptional = false } = {}) {
  if (!brief?.items?.length) return [];
  return brief.items.filter((i) => includeOptional || !i.only_if).map((i) => {
    let label = ITEM_NB[i.item] || i.item;
    const size = /(\d{3})(?:-\d{3})? x 200/.exec(i.spec || "");
    if (i.item === "bed" && size) label = `seng ${size[1]} cm`;
    if (/small/.test(i.spec || "") && i.item === "rug") label = "lite teppe";
    if (i.only_if) label += " (hvis plass)";
    return label;
  });
}

/** "Umøblert · Anbefalt styling" - the owner's two facts, no dangling separators. */
export function ownerSummary(oc) {
  if (!oc) return null;
  const parts = [oc.furnishing ? FURNISHING_NB[oc.furnishing] || oc.furnishing : null];
  const level = oc.styling_level || (oc.styling === "off" ? "none" : null);
  if (level) parts.push(STYLING_LEVEL_NB[level] || level);
  else if (oc.styling) parts.push(oc.styling === "digihome" ? "DigiHome-styling" : "Ingen styling");
  return parts.filter(Boolean).join(" · ") || null;
}
